<template lang="pug">
div
  app-divider(:label="titulo")
  el-row(:gutter="30")
    el-col(:span="6")
      validation-provider(:rules="isRequired", v-slot="{ errors }", name="Imóvel/Nome do beneficiário")
        app-label(label="Nome do beneficiário:", :required="required")
        el-input.input(
          v-model="imovel.nomeBeneficiarioTitulo",
          name='Nome do beneficiário',
          maxlength="300",
          :class="{'erro' : errors.length}"
        )
        span.help.erro {{ errors[0] }}
    el-col(:span="6")
      validation-provider(:rules="isLiberacao ? '' : isRequired", v-slot="{ errors }", name="Imóvel/CNS")
        app-label(label="CNS:", :required="isLiberacao ? false : required")
        el-input.input(
          v-model="imovel.cnsMatricula",
          name='CNS',
          maxlength="50"
          :class="{'erro' : errors.length}"
        )
        span.help.erro {{ errors[0] }}

    el-col(:span="6")
      validation-provider(:rules="isRequired", v-slot="{ errors }", name="Imóvel/Número")
        app-label(:label="isLiberacao ? 'Número da matrícula:' : 'Número:'", :required="required")
        el-input.input(
          v-model="imovel.numeroMatricula",
          name='Número',
          maxlength="50",
          :class="{'erro' : errors.length}"
        )
        span.help.erro {{ errors[0] }}

    el-col(:span="6")
      validation-provider(:rules="isRequired", v-slot="{ errors }", name="Imóvel/Livro")
        app-label(label="Livro:", :required="required")
        el-input.input(
          v-model="imovel.livroMatricula",
          name='Livro',
          maxlength="50"
          :class="{'erro' : errors.length}"
        )
        span.help.erro {{ errors[0] }}
  el-row(:gutter="30")
    el-col(:span="6")
      validation-provider(:rules="isLiberacao ? '' : isRequired", v-slot="{ errors }", name="Imóvel/Nº da folha")
        app-label(label="Nº da folha:", :required="isLiberacao ? false : required")
        el-input.input(
          v-model="imovel.numeroFolhaMatricula",
          name='Número da folha',
          maxlength="50",
          :class="{'erro' : errors.length}"
        )
        span.help.erro {{ errors[0] }}
    el-col(:span="6")
      validation-provider(:rules="isRequired", v-slot="{ errors }", name="Imóvel/Data do registro")
        app-label(label="Data do registro:", :required="required")
        el-date-picker.input.full-width(
          type="date",
          name='Data do registro'
          v-model="imovel.dataRegistro",
          placeholder="Selecione",
          format="dd/MM/yyyy",
          v-mask="'##/##/####'",
          :picker-options="pickerOptions",
          :class="{'erro' : errors.length}"
        )
        span.help.erro {{ errors[0] }}
    el-col(:span="6")
      validation-provider(:rules="isRequired", v-slot="{ errors }", name="Imóvel/Nome do cartório")
        app-label(label="Nome do cartório:", :required="required")
        el-input.input(
          v-model="imovel.nomeCartorio",
          name='Nome do cartório',
          maxlength="300",
          :class="{'erro' : errors.length}"
        )
        span.help.erro {{ errors[0] }}
    el-col(:span="6")
      validation-provider(:rules="isRequired", v-slot="{ errors }", name="Imóvel/Município do cartório")
        app-label( label="Município do cartório:", :required="required")
        el-select.input(
          style="display: block"
          class="select",
          v-model="imovel.municipioCartorio",
          no-match-text="Nenhum Município Encontrado",
          placeholder="Selecione",
          filterable,
          clearable,
          @clear="imovel.municipioCartorio = null"
          value-key="id",
          name="Município do cartório",
          :class="{'erro' : errors.length}"
        )
          el-option(
            v-for="item in municipios",
            :key="item.id",
            :label="item.nome",
            :value="item"
          )
        span.help.erro {{ errors[0] }}
</template>
<script>
import AppDivider from '@/components/AppDivider'
import AppLabel from '@/components/AppLabel'
const {inputsExtraCadastro} = require('@/utils/' + process.env.ESTADO + '/regrasCentral').default

export default {
  components: {
    AppDivider,
    AppLabel
  },
  data () {
    return {
      inputsExtraCadastro,
      pickerOptions: {
        disabledDate (time) {
          return time.getTime() > Date.now()
        }
      },
      municipios: []
    }
  },
  props: {
    imovel: {
      required: true
    },
    // prop que define se os campos são obrigatorios
    required: {
      type: Boolean,
      default: true
    },
    titulo: {
      type: String,
      required: false,
      default: 'Matrícula'
    },
    isLiberacao: {
      type: Boolean,
      required: false,
      default: false
    }
  },

  created () {
    this.getMunicipiosByUf()
  },

  computed: {
    isRequired () {
      return this.required ? 'required' : ''
    }
  },
  methods: {
    async getMunicipiosByUf () {
      this.municipios = await this.$store.dispatch(`municipios/findMunicipiosByUf`, process.env.ESTADO)
    }
  }
}
</script>
<style lang="scss" scoped>
.el-row {
  margin-bottom: 20px;
}

.full-width {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/screens/central/cadastros/maranhao/liberacao/components/MatriculaTituloImovel.vue